import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Order } from '@lib/entities';

export interface OrderState {
    previousOrders: Order[];
    isLoading: boolean;
    hasMore: boolean;
    currentPage: number;
    order?: Order;
    isReorder: boolean;
}

const initialState: OrderState = {
    previousOrders: [],
    isLoading: false,
    hasMore: false,
    currentPage: 0,
    order: undefined,
    isReorder: false
};

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setOrder: (state, action: PayloadAction<Order | undefined>) => {
            state.order = action.payload;
        },
        setIsReorder: (state, action: PayloadAction<boolean>) => {
            state.isReorder = action.payload;
        },
        resetIsReorder: (state) => {
            state.isReorder = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setPreviousOrders: (state, action: PayloadAction<Order[]>) => {
            state.previousOrders = action.payload;
        },
        appendPreviousOrders: (state, action: PayloadAction<Order[]>) => {
            state.previousOrders = state.previousOrders.concat(action.payload);
        },
        setHasMore: (state, action: PayloadAction<boolean>) => {
            state.hasMore = action.payload;
        },
        setCurrentPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        resetOrder: (state) => {
            return initialState;
        },
        // Saga triggers
        fetchOrderDetailRequest: (state, action: PayloadAction<number>) => {
            state.isLoading = true;
        },
        fetchPreviousOrdersRequest: (
            state,
            action: PayloadAction<{ userId: number; pageSize: number }>
        ) => {
            state.isLoading = true;
        },
        loadMoreOrdersRequest: (
            state,
            action: PayloadAction<{ userId: number; pageSize: number }>
        ) => {
            state.isLoading = true;
        }
    }
});

export const {
    setOrder,
    setIsReorder,
    resetIsReorder,
    setLoading,
    setPreviousOrders,
    appendPreviousOrders,
    setHasMore,
    setCurrentPage,
    resetOrder,
    fetchOrderDetailRequest,
    fetchPreviousOrdersRequest,
    loadMoreOrdersRequest
} = orderSlice.actions;

export const selectOrderState = (state: { order: OrderState }) => state.order;
export const selectOrder = (state: { order: OrderState }) => state.order.order;
export const selectIsReorder = (state: { order: OrderState }) => state.order.isReorder;

export default orderSlice.reducer;
